export default __webpack_public_path__ + "content/media/Black-IcoInstagram.6894777f.svg";